// extracted by mini-css-extract-plugin
var _1 = "AppointmentFollowUpModal-modulebody__OX0Nt";
var _2 = "AppointmentFollowUpModal-modulelines__dG65k";
export { _1 as "body", _2 as "lines" }
